import axios from "axios";

import { setBankId } from "./config-actions";
import console from "../utils/functions/console";
import { getErrorResponseMessage } from '../utils/functions/response';
import { RESPONSE_HEADER } from "../utils/enums";

export const fetchMasterData = (axiosObject) => async dispatch => {
  try {
    await axios[axiosObject.request.type](
      axiosObject.url,
      axiosObject.json,
      axiosObject.request.config
    ).then(masterdataResult => {
      if (
        masterdataResult &&
        masterdataResult.data &&
        masterdataResult.data.header &&
        masterdataResult.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL
      ) {

        if (masterdataResult.data.stammdaten && masterdataResult.data.stammdaten.gebuehren) {
          dispatch(setMasterData(masterdataResult.data.stammdaten));
          dispatch(setBankId(masterdataResult.data.stammdaten.gebuehren.bankleitzahl));
        } else if (window.localStorage && localStorage.getItem('gebuehren')) {
          const gebuehren = JSON.parse(localStorage.getItem('gebuehren'));
          dispatch(setGebuehren(gebuehren));
        }
        return masterdataResult.data;
      } else {
        console.log(masterdataResult && masterdataResult.data);
        if (masterdataResult && masterdataResult.data) {
          const message = getErrorResponseMessage(masterdataResult) || "e5: Ein Übertragungsfehler ist aufgetreten";
          throw new Error(message);
        }
      }
    });
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export function addItem(data) {
  return {
    type: "ADD",
    payload: data
  };
}

export function changeAmount(data, amount) {
  return {
    type: "CHANGE_AMOUNT",
    payload: data,
    amount: amount
  };
}

export function incrementItem(data) {
  return {
    type: "INCREMENT_ITEM",
    payload: data
  };
}

export function decrementItem(data) {
  return {
    type: "DECREMENT_ITEM",
    payload: data
  };
}

export function removeItem(data) {
  return {
    type: "REMOVE_ITEM",
    payload: data
  };
}

export function setMasterData(stammdaten) {
  return {
      type: "SET_MASTER_DATA",
      stammdaten: stammdaten
  };
}

export function setGebuehren(newGebuehren) {
  return {
      type: "SET_GEBUEHREN",
      gebuehren: newGebuehren
  };
}

export function setCurrentShopIsAnkauf(isAnkaufShop) {
  return {
    type: "SET_CURRENT_SHOP_IS_ANKAUF",
    payload: isAnkaufShop
  };
}

export function changeDues(item, due) {
  return {
    type: "CHANGE_DUES",
    item: item,
    due: due
  };
}

export function changeShipping(value) {
  return {
    type: "CHANGE_SHIPPING",
    payload: value
  };
}

export function resetFilialeAndShipment() {
  return {
    type: "RESET_FILIALE_AND_SHIPMENT",
  };
}

export function setDoShip(doShip) {
  return {
    type: "SET_DO_SHIP",
    payload: doShip
  };
}

export function updateSum(doShip) {
  return {
    type: "BASKET_UPDATE_SUM",
    payload: doShip
  };
}

export function setWarenkorbId(id) {
  return {
    type: "SET_WARENKORB_ID",
    payload: id
  };
}

export function setDataForOrder(data) {
  return {
    type: "SET_DATA_FOR_ORDER",
    data: data
  };
}

export function rebuildForApproval(data) {
  return {
    type: "BASKET_REBUILD_FOR_APPROVAL",
    data: data
  };
}

export function restoreData(data) {
  return {
      type: "RESTORE_DATA",
      payload: data
  };
}

export function setSelectedFiliale(filiale) {
  return {
    type: "SET_SELECTED_FILIALE",
    payload: filiale
  };
}

export function resetWarenkorb() {
  return {
    type: "RESET_WARENKORB",
  };
}

export function setBankApiResponseData(bankApiResponseData) {
  return {
    type: "SET_BANKAPIRESPONSEDATA",
    payload: bankApiResponseData
  };
}

export function setOrderLimit() {
  return (dispatch, getState) => {
    dispatch({
      type: "SET_ORDER_LIMIT",
      state: getState()
    });
  };
}
